import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo4/costamar.png";
import Imagen2 from "../../../images/modulo4/selvaplantas.png";
import Imagen3 from "../../../images/modulo4/selvaamazonica.png";
import Card from "../../../components/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 3.mp3";

const Actividad3 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "COSTA" },
    ans2: { value: "", valid: "", correctValue: "SELVA" },
    ans3: { value: "", valid: "", correctValue: "SIERRA" },
  });
  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[2];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo4.content[0].activities[3].name}`,
    linkNext: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[3].path}`,
    titlePrev: `${modulo4.content[0].activities[1].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[1].path}`,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo4.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">Actividad 3</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Los paisajes de nuestro país son muy variados.</li>
        <li>
          Observa las imágenes y completa las oraciones con las siguientes
          palabras:
        </li>
      </ul>
      <div className="row">
        <div className="col-lg-8 col-12">
          <Card>
            <div className="d-flex justify-content-around">
              <div>
                <strong>sierra</strong>
              </div>{" "}
              <div>
                <strong>costa</strong>
              </div>{" "}
              <div>
                <strong>selva</strong>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <div className="row mt-5 align-items-center">
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <p>
              1. Este es un paisaje <strong>desértico</strong>.
            </p>
            <p>En el Perú, encontramos este tipo de paisaje en la</p>
            <input
              type="text"
              className={"form-control " + answers.ans1.valid}
              value={answers.ans1.value}
              onChange={(event) => handleAnswers(event, "ans1")}
            />
            <p className="mt-3">
              Este es un paisaje mayormente seco y próximo a mar. Entre las
              plantas que viven en la zona se encuentra el algarrobo y entre los
              animales que habitan el paisaje se encuentran los lobos de mar.
            </p>
          </Card>
        </div>
        <div className="col-lg-8 col-md-6 col-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <p>
              2. Este es un paisaje de <strong>bosque húmedo</strong>.
            </p>
            <p>En el Perú, encontramos este tipo de paisaje en la</p>
            <input
              type="text"
              className={"form-control " + answers.ans2.valid}
              value={answers.ans2.value}
              onChange={(event) => handleAnswers(event, "ans2")}
            />
            <p className="mt-3">
              Este es un paisaje con mucha vegetación, gran biodiversidad y ríos
              caudalosos. Entre las plantas que viven en la zona están los
              plátanos y entre los animales que habitan el paisaje se encuentran
              los loros.
            </p>
          </Card>
        </div>
        <div className="col-lg-8 col-md-6 col-12">
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <p>
              3. Este es un paisaje <strong>montañoso</strong>.
            </p>
            <p>En el Perú, encontramos este tipo de paisaje en la</p>
            <input
              type="text"
              className={"form-control " + answers.ans3.valid}
              value={answers.ans3.value}
              onChange={(event) => handleAnswers(event, "ans3")}
            />
            <p className="mt-3">
              Este es un paisaje de grandes montañas, valles y ríos. Entre las
              plantas que viven en la zona se encuentra la papa y entre los
              animales que habitan el paisaje se encuentra la llama.
            </p>
          </Card>
        </div>
        <div className="col-lg-8 col-md-6 col-12">
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-11 col-12">
          <div className="d-flex w-100 justify-content-end my-4">
            <button
              className={`btn btn-${modulo4.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y describan lo que se ve.
          Pregunte si han visto los paisajes que se observan en las imágenes y
          dónde. Finalice señalando la importancia de la Cordillera de los Andes
          como elemento que atraviesa y marca nuestro territorio.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
